import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from "@ngx-translate/core";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-free-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form.component.html',
    styleUrls: ['./free-form.component.scss'],
    standalone: false
})
export class FreeFormComponent {
  @ViewChild('edit_overlay_template_scroll_panel', {static: false}) editPanelScrollPanel: ElementRef<HTMLDivElement>;
  
  annotation: FlatModels.AnnotationEntityModels.FreeForm;
  readonly FlatModels = FlatModels;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      if (this.annotation?.id !== annotation?.id && this.editPanelScrollPanel) {
        this.editPanelScrollPanel.nativeElement.scrollTop = 0;
      }
      this.annotation = structuredClone(annotation) as FlatModels.AnnotationEntityModels.FreeForm;
    });
  }
}
